
import { FullFTLOrderT } from '@/core/types/orders.types'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        ftlOrder: {
            type: Object as PropType<FullFTLOrderT>,
            default: null,
        },
    },
})
